<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="small"
      cell-class-name="align-top"
      resizable
      :seq-config="{
        startIndex: 0,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:fabircInfo="{ row }">
        <span>{{ row.fabricColorNo }}</span>
        <br />
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ `${row.fabricWeight} ${row.v_fabricWeightUnit}` }}</span>
      </template>
      <template v-slot:fabircColor="{ row }">
        <span>{{ row.fabricColorTitle }}</span>
        <br />
        <span>{{ row.fabricColorTitleEn }}</span>
      </template>
      <template v-slot:fabircContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>

      <template v-slot:fabircProductColor="{ row }">
        <span>{{ row.fabricColorTitle }}</span>
        <br />
        <span>{{ row.fabricColorTitleEn }}</span>
      </template>

      <template v-slot:fabircScm="{ row }">
        <span>{{ row.scmName }}</span>
        <div style="margin-top: 10px">
          <span v-if="row.isSpecify == 'Y'" class="tag specify">{{
            $l('label_value_specify') || '指定供应商'
          }}</span>
          <span
            v-if="row.isCustomerProvide == 'Y'"
            class="tag ml-2 customer-provide"
            >{{ $l('label_value_provide') || '客供' }}</span
          >
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                v-show="opt.show == undefined ? true : opt.show(row)"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.openEditPage({
            pageType: menuType,
            params: { devTrackingCode: data.devTrackingCode },
            query: { devTrackingNo: data.devTrackingNo },
          })
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.tag {
  padding: 5px;
  border-radius: 4px;
  height: 15px;
  line-height: 15px;
  color: #ffffff;
}
.specify {
  background-color: #e99d42;
}
.customer-provide {
  background-color: #fa5c7c;
}
</style>
